// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 647 ? "second" : chunkId) + "." + {"549":"9ca7e7d3","647":"6215ad8a"}[chunkId] + ".css";
};